import { createApp } from 'vue';
import { format } from 'date-fns';

import imageUrl from './utils/image-url';
import formatDate from './utils/format-date';
import formatTime from './utils/format-time';
import formatDateRange from './utils/format-date-range';
import formatPrice from './utils/format-price';
import pluralize from './utils/pluralize';
import innerHtml from './utils/inner-html';
import asComposer from './utils/as-composer';
import displayName from './utils/display-name';

import { bookingStatuses, buttonStates } from './services/booking';

import Translate from './plugins/Translate';
import EventBooking from './components/EventBooking.vue';
import FavoriteArtist from './components/FavoriteArtist.vue';
import FavoriteEvent from './components/FavoriteEvent.vue';
import FavoriteInstance from './components/FavoriteInstance.vue';
import InitialFavoriteDialog from './components/InitialFavoriteDialog.vue';
import EventFavoriteDialog from './components/EventFavoriteDialog.vue';
import EventCalendar from './components/EventCalendar.vue';
import CalendarMonths from './components/CalendarMonths.vue';
import DateSelector from './components/DateSelector.vue';
import CalendarArtistsProgram from './components/CalendarArtistsProgram.vue';
import AutoSuggest from './components/AutoSuggest.vue';
import SearchResults from './components/SearchResults.vue';
import FavoritedEvents from './components/FavoritedEvents.vue';
import FavoritedArtists from './components/FavoritedArtists.vue';
import PackageList from './components/PackageList.vue';
import MembershipLevelsBenefits from './components/MembershipLevelsBenefits.vue';
import BasketTimer from './components/BasketTimer.vue';
import AccountMenu from './components/AccountMenu.vue';
import Roster from './components/Roster.vue';
import TransportationMap from './components/TransportationMap.vue'
import SeriesBooking from './components/SeriesBooking.vue';
import ArticleList from './components/ArticleList.vue';
import RelatedArticles from './components/RelatedArticles.vue';
import FollowedArtist from './components/FollowedArtist.vue';
import NewsletterSignup from './components/NewsletterSignup.vue';
import RecommendedEvents from './components/RecommendedEvents.vue';

document.addEventListener('DOMContentLoaded', () => {
    for (const element of document.querySelectorAll('[data-component] [data-component]')) {
        element.removeAttribute('data-component');
    }

    for (const element of document.querySelectorAll('[data-component]')) {
        if (element.__vue_app__) {
            continue;
        }

        element.removeAttribute('data-component');

        const app = createApp({
            delimiters: ['[[', ']]'],
            template: element.outerHTML,
        });

        app.config.globalProperties.$imageUrl = imageUrl;
        app.config.globalProperties.$bookingStatuses = bookingStatuses;
        app.config.globalProperties.$buttonStates = buttonStates;
        app.config.globalProperties.$formatDate = formatDate;
        app.config.globalProperties.$formatTime = formatTime;
        app.config.globalProperties.$formatDateRange = formatDateRange;
        app.config.globalProperties.$formatPrice = formatPrice;
        app.config.globalProperties.$dateFnsFormat = format;
        app.config.globalProperties.$pluralize = pluralize;
        app.config.globalProperties.$innerHtml = innerHtml;
        app.config.globalProperties.$asComposer = asComposer;
        app.config.globalProperties.$displayName = displayName;

        app.use(Translate);

        app.config.warnHandler = (msg, instance, trace) => {
            if (msg.includes('data-component')) {
                return;
            }

            console.warn(msg, trace)
        }

        app.component('event-booking', EventBooking);
        app.component('favorite-artist', FavoriteArtist);
        app.component('favorite-event', FavoriteEvent);
        app.component('favorite-instance', FavoriteInstance);
        app.component('initial-favorite-dialog', InitialFavoriteDialog);
        app.component('event-favorite-dialog', EventFavoriteDialog);
        app.component('event-calendar', EventCalendar);
        app.component('calendar-months', CalendarMonths);
        app.component('date-selector', DateSelector);
        app.component('calendar-artists-program', CalendarArtistsProgram);
        app.component('auto-suggest', AutoSuggest);
        app.component('search-results', SearchResults);
        app.component('favorited-events', FavoritedEvents);
        app.component('favorited-artists', FavoritedArtists);
        app.component('package-list', PackageList);
        app.component('membership-levels-benefits', MembershipLevelsBenefits);
        app.component('basket-timer', BasketTimer);
        app.component('account-menu', AccountMenu);
        app.component('roster', Roster);
        app.component('transportation-map', TransportationMap);
        app.component('series-booking', SeriesBooking);
        app.component('article-list', ArticleList);
        app.component('related-articles', RelatedArticles);
        app.component('followed-artist', FollowedArtist);
        app.component('newsletter-signup', NewsletterSignup);
        app.component('recommended-events', RecommendedEvents);

        app.mount(element);

        element.__vue_app__ = app;
    }
});
